/* eslint-disable arrow-body-style */
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {inject} from "@angular/core";
import {Store} from "@ngrx/store";
import {catchError, exhaustMap, filter, map, of} from "rxjs";
import {ErrorHandlingUtil} from "../../utils/error-handling-util";
import {PatternService} from "../../services/pattern/pattern.service";
import {PatternActions} from "../shared.actions";
import {MatSnackBar} from "@angular/material/snack-bar";
import {tap} from "rxjs/operators";
import {concatLatestFrom} from "@ngrx/operators";
import {selectPatternFilterQuery} from "./pattern.selectors";

export const loadPatternList = createEffect(
    (store$ = inject(Store), actions$ = inject(Actions), patternService = inject(PatternService)) => {
        return actions$.pipe(
            ofType(PatternActions.loadAll),
            exhaustMap((action) =>
                patternService.getPatterns(action.patternFilterQuery).pipe(
                    map((patterns) => PatternActions.loadAllSuccess({patterns})),
                    catchError((errorResponse: any) => of(PatternActions.loadAllError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                )
            )
        );
    },
    {functional: true}
);

export const savePattern = createEffect(
    (actions$ = inject(Actions), patternService = inject(PatternService)) => {
        return actions$.pipe(
            ofType(PatternActions.save),
            filter(action => !action.fundValuationId),
            exhaustMap((action) =>
                patternService.savePattern(action.pattern, action.pattern.id, action.originPatternId).pipe(
                    map((pattern) => PatternActions.saveSuccess({pattern})),
                    catchError((errorResponse: any) => of(PatternActions.saveError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                )
            )
        );
    },
    {functional: true}
);

export const showSaveSuccess = createEffect(
    (actions$ = inject(Actions), snackBar = inject(MatSnackBar)) => {
        return actions$.pipe(
            ofType(PatternActions.saveSuccess),
            tap(() => {
                snackBar.open("Pattern saved successfully.", "", {duration: 3000});
            })
        );
    },
    {functional: true, dispatch: false}
);

export const archivePattern = createEffect(
    (store$ = inject(Store), actions$ = inject(Actions), patternService = inject(PatternService)) => {
        return actions$.pipe(
            ofType(PatternActions.updateArchiveStatus),
            exhaustMap((action) =>
                patternService.updatePatternArchiveStatus(action.patternId, action.filterQuery).pipe(
                    map((patterns) => PatternActions.loadAllSuccess({patterns})),
                    catchError((errorResponse: any) => of(PatternActions.updateArchiveStatusError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                )
            )
        );
    },
    {functional: true}
);

export const showArchiveSuccess = createEffect(
    (actions$ = inject(Actions), snackBar = inject(MatSnackBar)) => {
        return actions$.pipe(
            ofType(PatternActions.updateArchiveStatusSuccess),
            tap(() => {
                snackBar.open("Updated pattern archive status successfully.", "", {duration: 3000});
            })
        );
    },
    {functional: true, dispatch: false}
);

export const markPatternAsFavourite = createEffect(
    (store$ = inject(Store), actions$ = inject(Actions), patternService = inject(PatternService)) => {
        return actions$.pipe(
            ofType(PatternActions.updateFavouriteStatus),
            exhaustMap((action) =>
                patternService.updatePatternFavouriteStatus(action.patternId, action.filterQuery).pipe(
                    map((patterns) => PatternActions.loadAllSuccess({patterns})),
                    catchError((errorResponse: any) => of(PatternActions.updateFavouriteStatusError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                )
            )
        );
    },
    {functional: true}
);

export const reloadPatterns = createEffect(
    (store$ = inject(Store), actions$ = inject(Actions)) => {
        return actions$.pipe(
            ofType(PatternActions.saveSuccess),
            concatLatestFrom(() => store$.select(selectPatternFilterQuery)),
            map(([, filterQuery]) => PatternActions.loadAll({patternFilterQuery: filterQuery}))
        );
    },
    {functional: true}
);

export const reloadPatternsOnQueryUpdate = createEffect(
    (actions$ = inject(Actions)) => {
        return actions$.pipe(
            ofType(PatternActions.updatePatternFilterQuery),
            map(action => PatternActions.loadAll({patternFilterQuery: action.filterQuery}))
        );
    },
    {functional: true}
);
